import { render, staticRenderFns } from "./WorkflowList.vue?vue&type=template&id=0c2e003f&scoped=true"
import script from "./WorkflowList.vue?vue&type=script&lang=js"
export * from "./WorkflowList.vue?vue&type=script&lang=js"
import style0 from "./WorkflowList.vue?vue&type=style&index=0&id=0c2e003f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2e003f",
  null
  
)

export default component.exports